import { render, staticRenderFns } from "./BackOrderFulfillments.vue?vue&type=template&id=18b30ede&scoped=true"
import script from "./BackOrderFulfillments.vue?vue&type=script&lang=js"
export * from "./BackOrderFulfillments.vue?vue&type=script&lang=js"
import style0 from "./BackOrderFulfillments.vue?vue&type=style&index=0&id=18b30ede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b30ede",
  null
  
)

export default component.exports